import React from 'react';
import { AppShell } from './navigation/AppShell';
import { ImpersonationWriteGuardProvider } from '../contexts/ImpersonationWriteGuardContext';

interface LayoutProps {
  children: React.ReactNode;
}

/**
 * The authenticated application chrome. Every `/app/*` route renders inside it.
 *
 * The shell itself lives in `components/navigation/`; this file stays as the
 * import every route already points at.
 *
 * The write guard is mounted here (not in App.tsx) so every route that renders
 * the shell confirms live writes made while viewing as another account.
 */
export const Layout: React.FC<LayoutProps> = ({ children }) => (
  <ImpersonationWriteGuardProvider>
    <AppShell>{children}</AppShell>
  </ImpersonationWriteGuardProvider>
);

export default Layout;
